import { createContext, useContext } from 'react'
import type { User } from '@/api/types'

// 로그인한 사람. App 이 /auth/me 로 복구한 값을 화면이 읽는다 — 역할이 화면을 가르는 유일한 곳이다.
// Provider 는 components/Session.tsx 에 있다(컴포넌트와 훅을 한 파일에 두면 fast refresh 가 깨진다).

export const SessionCtx = createContext<User | null>(null)

export function useSession(): User {
  const user = useContext(SessionCtx)
  if (!user) throw new Error('useSession outside SessionProvider')
  return user
}

// 세션을 다시 읽는다(F-37). 내 정보에서 이름을 바꾸면 상단 바가 따라와야 한다.
export const SessionRefreshCtx = createContext<() => void>(() => undefined)

export function useRefreshSession(): () => void {
  return useContext(SessionRefreshCtx)
}
